import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { TimeRangeModel } from './timerange-picker.models';
import { Subject, debounceTime, takeUntil } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { ConvertTo24HourFormatPipe } from '@shared/utils/pipes';

@Component({
  selector: 'shared-ui-datetime-timerange-picker',
  templateUrl: './timerange-picker.component.html',
  styleUrls: ['./timerange-picker.component.css'],
  providers: [ConvertTo24HourFormatPipe],
  standalone: false,
})
export class TimeRangePickerComponent implements OnInit, OnDestroy {
  @Output() emitTimeRange: EventEmitter<TimeRangeModel> = new EventEmitter<TimeRangeModel>();

  @Input() useMilitaryTime = false;

  timeRangeForm = new FormGroup({
    fromTime: new FormControl<Date | null>(null),
    toTime: new FormControl<Date | null>(null),
  });

  private ngUnsubscribe = new Subject<void>();

  constructor() {}

  ngOnInit(): void {
    this.timeRangeForm.valueChanges.pipe(debounceTime(300), takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      const { fromTime, toTime } = value;

      if (fromTime && toTime) {
        const formattedFrom = this.formatTimeAsUTC(fromTime);
        const formattedTo = this.formatTimeAsUTC(toTime);

        this.emitTimeRange.emit(new TimeRangeModel(formattedFrom, formattedTo));
      }
    });
  }

  onFromTimeBlur(): void {
    const currentValue = this.timeRangeForm.controls.fromTime.value;
    if (!currentValue) {
      this.timeRangeForm.controls.fromTime.setValue(new Date());
    }
  }

  onToTimeBlur(): void {
    const currentValue = this.timeRangeForm.controls.toTime.value;
    if (!currentValue) {
      this.timeRangeForm.controls.toTime.setValue(new Date());
    }
  }

  reset(): void {
    this.timeRangeForm.reset();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private formatTimeAsUTC(date: Date): string {
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
}
